import React, { PropsWithChildren } from 'react';

import { Marker } from './marker';
import { Pointer } from './types';

import classes from './map-marker.module.scss';

type MarkerProps = {
  pointer: Pointer;
  handleClick: () => void;
  disabled?: boolean;
};

export const MapMarker = ({
  pointer,
  handleClick,
  children,
  disabled,
}: PropsWithChildren<MarkerProps>) => (
  <Marker
    className={classes.mapMarker}
    pointer={pointer}
    onclick={handleClick}
    disabled={disabled}
  >
    {children}
  </Marker>
);
